import React from "react";
import styled from "@emotion/styled";
import { breakpoints } from "../hooks/useBreakpoint";
import Deathy from "./Deathy";
import useWindowSize from "../hooks/useWindowSize";
import mq from "../utils/mediaQueries";

const Wrapper = styled.div`
  grid-area: footer;
  width: 100%;

  display: flex;
  padding-top: 1rem;
  padding-bottom: 1rem;
  flex-direction: row;
`;

const Text = styled.p`
  color: ${({ theme }) => theme.header};
  text-align: left;
  justify-self: flex-start;
  align-self: center;
  flex: 1;

  ${mq("sm")} {
    align-self: flex-end;
  }

  ${mq("lg")} {
    text-align: center;
  }
`;

const DeathyWrapper = styled.div`
  width: 100px;
  justify-self: flex-end;
  align-self: flex-end;
`;

const Footer = () => {
  const { width } = useWindowSize();

  return (
    <Wrapper>
      <Text>
        Death in Space is copyright Stockholm Kartell. Web app by Karl Druid.
      </Text>
      {width < breakpoints.lg && (
        <DeathyWrapper>
          <Deathy />
        </DeathyWrapper>
      )}
    </Wrapper>
  );
};

export default Footer;
